import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IProps from "./IProps";
import "../../../assets/sass/widgets/sectionTitle.scss";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { imagePathurl } from "../../utils/utils";
import { CustomAddButtonsWrapperContext } from "../CustomAddButtonsWrapper";

/**
 * @class SectionTitle
 * @description
 * NOTE:
 * Should expect CustomAddButtonWrapper as parent component
 * Because this component Consume from CustomAddButtonsWrapperContext Provider
 * @param props
 * @constructor
 * @category Widgets
 */
const SectionTitleWidget: React.FC<IProps> = (props) => {
    const { className, schema, id, formData } = props;
    const { sectionId, label, description, requiredCount, message } = schema.const;
    const [errorExist, seterrorExist] = React.useState(true);
    
    // Session Storage added to show accessories error in Review Error popup.
    if(schema.const['sectionId'] === 'requiredSection') {
        window.sessionStorage.setItem('requiredCount', schema.const['requiredCount']);
        window.sessionStorage.setItem('description', schema.const['description'])
    }
    // componentDidUpdate
    useEffect(() => {
        if (props.id && props.errorDetails[props.id]) {
            seterrorExist(true);
        } else {
            seterrorExist(false);
        }
    }, [props.errorDetails]);

    /**
     * @function getTitle
     * Consumer object can able to consume data
     * @param {section} section - Section values
     * @return {string}
     * @ignore
     */
    const getTitle = (section): string => {
        let title = label;
        const specificSection = section[sectionId];
        let adjustCount = 0;
        const projectDetails = formData.residentialWarrantyForm && formData.residentialWarrantyForm.projectDetails;
        if (
            sectionId === "requiredSection" &&
            projectDetails &&
            projectDetails.warrantyType === "SYSTEM_PLUS" &&
            projectDetails.jobType.typeOfJob === "RR" &&
            projectDetails.jobType.reRoofType === "RCOES"
        ) {
            adjustCount = 1;
        }
        if (specificSection) {
            if (requiredCount && !isNaN(specificSection.selectedCount)) {
                const count = parseInt(requiredCount, 10) - adjustCount;
                if (count > specificSection.selectedCount && label) {
                    title = label.replace("{count}", count - specificSection.selectedCount);
                } else {
                    if (props.id && props.errorDetails[props.id]) {
                        props.dynamicFormActions.removeFieldIdFromStore(props.id);
                    }
                    title = label.replace("{count}", "No");
                }
            }
        }
        return title;
    };

    /**
     * Replace description string if any selector values there
     * @return {string}
     */
    const getDescription = (): string => {
        let count = requiredCount;
        const projectDetails = formData.residentialWarrantyForm && formData.residentialWarrantyForm.projectDetails;
        if (
            sectionId === "requiredSection" &&
            projectDetails &&
            projectDetails.warrantyType === "SYSTEM_PLUS" &&
            projectDetails.jobType.typeOfJob === "RR" &&
            projectDetails.jobType.reRoofType === "RCOES"
        ) {
            count--;
        }
        return description && description.includes("requiredCount")
            ? description.replace("{requiredCount}", count)
            : description;
    };

    /**
     * Message to show once all custom add button shown
     * @param section
     * @return {string}
     */
    const showMessage = (section) => {
        const specificSection = section[sectionId];
        return specificSection.selectedCount === specificSection.totalCount ? message : "";
    };
    const imagePath = imagePathurl();
    return (
        <CustomAddButtonsWrapperContext.Consumer>
            {({ hasSection, sections }) => {
                if (!hasSection) return null;

                const title = getTitle(sections);
                const description = getDescription();
                const allAddedMessage = showMessage(sections);

                return (
                    <section className={`${className} clearfix`} id={id}>
                        {title && <div className="section-title">{title}</div>}
                        {description && errorExist && (
                            <div className={errorExist ? "section-error-message" : ""}>
                                <img className="ccz-img" src={`${imagePath}error-field-icon.png`} alt="error" />
                                &nbsp;
                                {description}
                            </div>
                        )}
                        {allAddedMessage && <div className={title && "section-message"}>{allAddedMessage}</div>}
                    </section>
                );
            }}
        </CustomAddButtonsWrapperContext.Consumer>
    );
};

export function mapStateToProps(state) {
    return {
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        formData: state.dynamicFormInfo.warrantyInfo || {},
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionTitleWidget);
